import React, { Component } from 'react'
import Header from '../Header'
import './VIIw.css'

class VIIw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyVIIw">
                    <p className="textVIIw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default VIIw